module.exports = __webpack_public_path__ + "static/media/add_prodOLD.950495de.svg";